import React from 'react';
import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Skeleton,
  Typography
} from '@material-ui/core';
import { orange } from '@material-ui/core/colors';
import ExtensionIcon from '@material-ui/icons/Extension';

export default function TotalRound({ loading, data }) {
  return (
    <Card>
      <CardContent>
        <Grid
          container
          sx={{ justifyContent: 'space-between' }}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              TOTAL ROUNDS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {loading ? <Skeleton /> : data?.total}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: orange[600],
                height: 56,
                width: 56
              }}
            >
              <ExtensionIcon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
